import { Link } from 'react-router-dom'

export default function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="relative overflow-hidden bg-neutral-950 text-warm-gray-300 border-t border-warm-gray-800">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0 select-none pointer-events-none">
        <img 
          src="https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=80,format=auto/assets/8ba53ab1-a105-4ab3-8373-4041e8d1e44e/footer-wood-background.jpg" 
          alt="" 
          className="w-full h-full object-cover opacity-15"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-neutral-950 via-transparent to-neutral-950/50" />
      </div>

      {/* Slanted solid brand-colored section on the right side */}
      <div className="absolute inset-y-0 right-0 w-1/4 sm:w-1/5 bg-brand-green pointer-events-none z-0" style={{ clipPath: 'polygon(35% 0, 100% 0, 100% 100%, 0 100%)' }} />

      {/* Main Footer Content */}
      <div className="relative z-10 mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          {/* Brand Column */}
          <div className="flex flex-col gap-4">
            <Link to="/" className="flex flex-col group">
              <span className="text-xl sm:text-2xl font-extrabold tracking-tight text-white transition-colors leading-tight">
                KRISTENSEN
              </span>
              <span className="text-[10px] sm:text-xs font-bold uppercase tracking-widest text-warm-gray-400 leading-none mt-1">
                BYG & MONTAGE ApS
              </span>
            </Link>
          </div>

          {/* Quick Links Column */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider text-white mb-6">Hurtige links</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/" className="hover:text-white transition-colors">Forside</Link>
              </li>
              <li>
                <Link to="/om-os" className="hover:text-white transition-colors">Om os</Link>
              </li>
              <li>
                <Link to="/porebeton" className="hover:text-white transition-colors">Porebeton</Link>
              </li>
              <li>
                <Link to="/renovering" className="hover:text-white transition-colors">Renovering</Link>
              </li>
              <li>
                <Link to="/nybyg" className="hover:text-white transition-colors">Nybyg</Link>
              </li>
              <li>
                <Link to="/kontakt" className="hover:text-white transition-colors">Kontakt</Link>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider text-white mb-6">Kontaktoplysninger</h3>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <i className="fa-light fa-location-dot text-brand-green-light mt-1 text-base" />
                <span>
                  Kristensen Byg og Montage ApS<br />
                  Bygade 51E<br />
                  7173 Vonge
                </span>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-light fa-phone text-brand-green-light text-base" />
                <a href="tel:+4528558925" className="hover:text-white transition-colors whitespace-nowrap">
                  28 55 89 25
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-light fa-envelope text-brand-green-light text-base" />
                <a href="mailto:kontakt@k-bm.dk" className="hover:text-white transition-colors whitespace-nowrap">
                  kontakt@k-bm.dk
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="relative z-10 bg-neutral-950/80 backdrop-blur-xs border-t border-warm-gray-900 py-6 text-center text-xs text-warm-gray-500">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p>© {currentYear} Kristensen Byg og Montage ApS. Alle rettigheder forbeholdes.</p>
          <p className="flex items-center gap-1.5">
            <span>Udviklet af</span>
            <span className="font-semibold text-warm-gray-400">Auxo</span>
          </p>
        </div>
      </div>
    </footer>
  )
}
